import { jsx as _jsx } from "react/jsx-runtime";
import { ChevronDown, ChevronUp } from 'lucide-react';
import { useEffect, useState } from 'react';
var ScrollContentButton = function (_a) {
    var contentId = _a.contentId;
    var _b = useState(false), showScrollUp = _b[0], setShowScrollUp = _b[1];
    useEffect(function () {
        var handleScroll = function () {
            setShowScrollUp(window.scrollY > 0);
        };
        handleScroll(); // initialize
        window.addEventListener('scroll', handleScroll);
        return function () { return window.removeEventListener('scroll', handleScroll); };
    }, []);
    var handleClick = function () {
        if (showScrollUp) {
            window.scrollTo({ behavior: 'smooth', top: 0 });
        }
        else {
            var el = document.getElementById(contentId);
            el === null || el === void 0 ? void 0 : el.scrollIntoView({ behavior: 'smooth' });
        }
    };
    return (_jsx("button", { "aria-label": showScrollUp ? 'Scroll to top' : 'Scroll to main content', className: "\n        fixed right-4 bottom-4 z-50\n        bg-primary text-white rounded-full shadow-lg\n        w-14 h-14 flex items-center justify-center\n        hover:bg-[#1594c5] focus:outline-none focus:ring-2 focus:ring-primary\n        md:right-6 md:bottom-6\n      ", onClick: handleClick, children: showScrollUp ? _jsx(ChevronUp, { size: 28 }) : _jsx(ChevronDown, { size: 28 }) }));
};
export default ScrollContentButton;
